<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        {{label}}
    </mat-label>

    <mat-select [formControl]="valueControl">
        <mat-option *ngFor="let issueType of IssueTypes" [value]="issueType">
            {{issueType|issueTypeName}}
        </mat-option>
    </mat-select>

</mat-form-field>
